import { ActionType as AT } from './enums/action-type.enum';
import { Question } from '../../models/question.model';
import { Service } from '../../models/service.model';
import { CallTimeFormRegime } from '../../models/call-time-form-regime.model';
import { Result } from './interfaces/result.interface';
import { ConvrTestVariation } from '../../interfaces/convr-test-variation.interface';

interface CheckAnswerArgs {
	questionId: number;
	value: string;
	checked: boolean;
	reset?: boolean;
}

export const defineQuestions = (questions:Question[]) => ({
	type: AT.DEFINE_QUESTIONS as typeof AT.DEFINE_QUESTIONS,
	payload: { questions }
});

export const checkAnswer = (answer:CheckAnswerArgs) => ({
	type: AT.CHECK_ANSWER as typeof AT.CHECK_ANSWER,
	payload: { ...answer }
});

export const quizIsPassed = (status:boolean) => ({
	type: AT.QUIZ_IS_PASSED as typeof AT.QUIZ_IS_PASSED,
	payload: { status }
});

export const updateCurrentService = (service:Service | 'selection') => ({
	type: AT.UPDATE_CURRENT_SERVICE as typeof AT.UPDATE_CURRENT_SERVICE,
	payload: { service }
});

export const toggleButtonBack = (status:boolean) => ({
	type: AT.TOGGLE_BUTTON_BACK as typeof AT.TOGGLE_BUTTON_BACK,
	payload: { status }
});

export const addCalculatorData = (data:{[key: string]:any}) => ({
	type: AT.ADD_CALCULATOR_DATA as typeof AT.ADD_CALCULATOR_DATA,
	payload: { data }
});

export const setCallTimeFormRegime = (regime: CallTimeFormRegime) => ({
	type: AT.SET_CALL_TIME_FORM_REGIME as typeof AT.SET_CALL_TIME_FORM_REGIME,
	payload: { regime }
});

export const addQuizResult = (result: Result) => ({
	type: AT.ADD_QUIZ_RESULT as typeof AT.ADD_QUIZ_RESULT,
	payload: { result }
});

export const removeQuizResult = (id: number) => ({
	type: AT.REMOVE_QUIZ_RESULT as typeof AT.REMOVE_QUIZ_RESULT,
	payload: { id }
});

export const toggleDoctor = (status:boolean) => ({
	type: AT.TOGGLE_DOCTOR as typeof AT.TOGGLE_DOCTOR,
	payload: { status }
});

export const toggleLabel = (status:boolean) => ({
	type: AT.TOGGLE_LABEL as typeof AT.TOGGLE_LABEL,
	payload: { status }
});

export const setQuizStarted = (status:boolean) => ({
	type: AT.SET_QUIZ_STARTED as typeof AT.SET_QUIZ_STARTED,
	payload: { status }
});

export const setSignUpOpened = (status: boolean) => ({
	type: AT.SET_SIGN_UP_OPENED as typeof AT.SET_SIGN_UP_OPENED,
	payload: { status }
});

export const toggleFlyingButton = (status:boolean) => ({
	type: AT.TOGGLE_FLYING_BUTTON as typeof AT.TOGGLE_FLYING_BUTTON,
	payload: { status }
});

export const getPhone = (status:boolean) => ({
	type: AT.GET_PHONE as typeof AT.GET_PHONE,
	payload: { status }
});

export const setQuizProgress = (progress:number) => ({
	type: AT.SET_QUIZ_PROGRESS as typeof AT.SET_QUIZ_PROGRESS,
	payload: { progress }
});

export const toggleButtonToCommon = (status:boolean) => ({
	type: AT.TOGGLE_BUTTON_TO_COMMON as typeof AT.TOGGLE_BUTTON_TO_COMMON,
	payload: { status }
});

export const toggleServiceListDropdownMenu = (status:boolean) => ({
	type: AT.TOGGLE_SERVICE_LIST_DROPDOWN_MENU as typeof AT.TOGGLE_SERVICE_LIST_DROPDOWN_MENU,
	payload: { status }
});

export const setConvrTestVariations = (variations: ConvrTestVariation[]) => ({
  type: AT.SET_CONVR_TEST_VARIATIONS as typeof AT.SET_CONVR_TEST_VARIATIONS,
  payload: { variations }
});

export const setPopupWidth = (width: number) => ({
  type: AT.SET_POPUP_WIDTH as typeof AT.SET_POPUP_WIDTH,
  payload: { width }
});

export const displayPopupWindow = (status: boolean) => ({
	type: AT.DISPLAY_POPUP_WINDOW as typeof AT.DISPLAY_POPUP_WINDOW,
	payload: { status }
});

export const setActivePopupWindowId = (id: string) => ({
	type: AT.SET_ACTIVE_POPUP_WINDOW_ID as typeof AT.SET_ACTIVE_POPUP_WINDOW_ID,
	payload: { id }
});